import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M8.4 4c.56 0 .84 0 1.054.11a1 1 0 0 1 .437.436C10 4.76 10 5.04 10 5.6v12.8c0 .56 0 .84-.11 1.054a.999.999 0 0 1-.436.437C9.24 20 8.96 20 8.4 20h-.8c-.56 0-.84 0-1.054-.11a.999.999 0 0 1-.437-.436C6 19.24 6 18.96 6 18.4V5.6c0-.56 0-.84.11-1.054a1 1 0 0 1 .436-.437C6.76 4 7.04 4 7.6 4h.8Zm8 0c.56 0 .84 0 1.054.11a1 1 0 0 1 .437.436C18 4.76 18 5.04 18 5.6v12.8c0 .56 0 .84-.11 1.054a.999.999 0 0 1-.436.437C17.24 20 16.96 20 16.4 20h-.8c-.56 0-.84 0-1.054-.11a.999.999 0 0 1-.437-.436C14 19.24 14 18.96 14 18.4V5.6c0-.56 0-.84.11-1.054a.999.999 0 0 1 .436-.437C14.76 4 15.04 4 15.6 4h.8Z"
    />
  </svg>
`;
